import React from 'react';

const PanchangBanner = () => {
  return (
    <div className="relative bg-gradient-to-br from-stone-900 via-amber-950 to-stone-900 rounded-3xl p-8 md:p-12 mb-10 overflow-hidden shadow-2xl border-b-4 border-saffron-500">
      {/* Decorative Ornaments & Glowing Blobs */}
      <div className="absolute top-0 right-0 w-80 h-80 bg-saffron-600 rounded-full mix-blend-multiply filter blur-[90px] opacity-30 -mr-20 -mt-20"></div>
      <div className="absolute bottom-0 left-0 w-80 h-80 bg-orange-600 rounded-full mix-blend-multiply filter blur-[90px] opacity-25 -ml-20 -mb-20"></div>
      
      {/* Repeating Traditional Background Mandalas */}
      <div className="absolute top-1/2 right-10 -translate-y-1/2 opacity-10 pointer-events-none hidden md:block">
        <svg width="220" height="220" viewBox="0 0 100 100" className="animate-[spin_120s_linear_infinite] text-saffron-500">
          <circle cx="50" cy="50" r="40" fill="none" stroke="currentColor" strokeWidth="0.5" strokeDasharray="2,2" />
          <circle cx="50" cy="50" r="30" fill="none" stroke="currentColor" strokeWidth="0.8" />
          {Array.from({ length: 12 }).map((_, i) => {
            const angle = (i * 30 * Math.PI) / 180;
            const x1 = 50 + 30 * Math.cos(angle);
            const y1 = 50 + 30 * Math.sin(angle);
            const x2 = 50 + 40 * Math.cos(angle);
            const y2 = 50 + 40 * Math.sin(angle);
            return (
              <line
                key={i}
                x1={x1}
                y1={y1}
                x2={x2}
                y2={y2}
                stroke="currentColor"
                strokeWidth="0.8"
              />
            );
          })}
          {Array.from({ length: 24 }).map((_, i) => {
            const angle = (i * 15 * Math.PI) / 180;
            const x = 50 + 35 * Math.cos(angle);
            const y = 50 + 35 * Math.sin(angle);
            return <circle key={i} cx={x} cy={y} r="1" fill="currentColor" />;
          })}
        </svg>
      </div>

      <div className="relative z-10 flex flex-col md:flex-row items-center justify-between gap-8">
        <div className="text-center md:text-left max-w-2xl">
          <span className="inline-flex items-center space-x-1.5 px-3 py-1 rounded-full bg-saffron-500/10 text-saffron-400 font-semibold text-xs tracking-wider uppercase mb-4 border border-saffron-500/20">
            ☀️ वैदिक काल-गणना (Vedic Time Keeping)
          </span>
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-white mb-4 tracking-tight leading-tight">
            पंचांग 2026
            <span className="block text-xl sm:text-2xl font-medium text-saffron-400 mt-2">
              Panchang 2026 — Daily Hindu Calendar
            </span>
          </h1>
          <p className="text-stone-300 text-sm sm:text-base leading-relaxed">
            बरेली (नाथ नगरी) के भौगोलिक निर्देशांकों के आधार पर दैनिक तिथि, नक्षत्र, योग, करण एवं सूर्योदय-सूर्यास्त की अत्यंत सटीक गणना।
          </p>
          <div className="mt-2 text-stone-400 text-xs flex flex-wrap justify-center md:justify-start gap-4">
            <span>📍 अक्षांश (Lat): 28.3619° N</span>
            <span>📍 रेखांश (Lon): 79.4217° E</span>
            <span>🕒 समय क्षेत्र (TZ): GMT +5.5</span>
          </div>
        </div>

        {/* Traditional Aum/Ganesha Icon Area */}
        <div className="flex-shrink-0 w-24 h-24 sm:w-28 sm:h-28 rounded-full bg-gradient-to-br from-saffron-500 to-amber-600 flex items-center justify-center shadow-lg border-4 border-stone-850 hover:scale-105 transition-transform duration-300 group">
          <svg className="w-12 h-12 text-stone-900 group-hover:rotate-12 transition-transform duration-300" viewBox="0 0 24 24" fill="currentColor">
            {/* Elegant representation of a traditional diya / flame */}
            <path d="M12 2C11.5 4 9 7 9 9.5C9 11.5 10.3 13 12 13C13.7 13 15 11.5 15 9.5C15 7 12.5 4 12 2Z" />
            <path d="M12 13C7 13 4 16.5 4 19.5C4 20.3 4.7 21 5.5 21H18.5C19.3 21 20 20.3 20 19.5C20 16.5 17 13 12 13Z" />
          </svg>
        </div>
      </div>
    </div>
  );
};

export default PanchangBanner;
